import VueI18n from "vue-i18n"
import Vue from "vue"
import env from "./assets/js/env"

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || "en-US", //语言标识
  messages: {
    "en-US": require("./locales/en-US.json"), // 英文
    "zh-CN": require("./locales/zh-CN.json"), // 中文
  },
  fallbackLocale: "en-US",
})

// 先应用公共文案，再应用当前品牌文案；未覆盖的条目沿用原翻译。
const runtimeConfig = window.__RUNTIME_CONFIG__ || {}
const messageOverrides = [(runtimeConfig.common || {}).messages, env.messages]
messageOverrides.forEach(messages => {
  Object.keys(messages || {}).forEach(locale => {
    i18n.mergeLocaleMessage(locale, messages[locale])
  })
})

export default i18n
